import { render, staticRenderFns } from "./LifecycleTrigger.vue?vue&type=template&id=61628702&"
import script from "./LifecycleTrigger.vue?vue&type=script&lang=js&"
export * from "./LifecycleTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports